module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "body-text3"
  }, [_vm._v("If you’re already a fan of mixed martial arts, in particular the Ultimate Fighting Championship (UFC), then you’re probably familiar with moves like triangle choke, spinning heel kick, and Kimura. If not, check out the MMA terms and weight classes in the back of the book. You can also go online for videos of famous fights and training videos. Amateur fights are similar to the pros but require more protection for the fighters. While there are unified rules, each state allows for variation.")]), _vm._v(" "), _c('p', {
    staticClass: "frnt1"
  }, [_c('b', [_vm._v("WELCOME TO THE DOJO.")])]), _vm._v(" "), _c('p', {
    staticClass: "frnt2"
  }, [_c('b', [_vm._v("STEP INSIDE.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4bce3ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front2.vue
// module id = 72
// module chunks = 0